<template>

    <div id="stream"></div>

</template>

<script>

    import * as Config from '@/config'
    import Clappr from 'clappr';
    import ClapprGoogleImaHtml5PrerollPlugin from 'clappr-google-ima-html5-preroll-plugin';

	export default {
		name: 'Video-Page-Test',
		data () {
			return {
				player: null,
            }
        },
        props: [
            'streamId',
            'watermark',
            'ads'
        ],
        watch: {
            streamId: function() {
                console.log(this.streamId)
                if(this.player !== null) {
                    var _this = this
		    this.player.load(Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8");
		    //this.player.destroy();
                    //this.player.configure({
                    //    source: Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8",
                    //    autoPlay: true,
                    //});
		    //this.initVid();
                }
            }
        },
		mounted() {
			this.initVid();
		},
		methods: {
            initVid() {
                var _this = this
                var playerElement = document.getElementById("stream")

                if(this.ads) {
                    if(this.watermark) {
                        this.player = new Clappr.Player({
                            source: Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8",
                            autoPlay: true,
                            plugins: {
                                core: [ClapprGoogleImaHtml5PrerollPlugin],
                            },
                            width: "100%",
                            height: "100%",
                            watermark: "https://i.lsc-wx.co/site/watermark.png",
                            position: 'top-right',
                            googleImaHtml5PrerollPlugin: {
                                tag: 'http://googleads.g.doubleclick.net/pagead/ads?ad_type=video&client=ca-video-pub-4968145218643279&videoad_start_delay=0&description_url=http%3A%2F%2Fwww.google.com&max_ad_duration=40000&adtest=on', // VAST tag URL (or false to disable plugin)
                                vpaid: 0, // Default is 0 (0 is DISABLED, 1 is ENABLED and 2 is INSECURE)
                                autostart: false, // Default is true
                                // events: { /* Event map */ },
                                // imaLoadTimeout: 3000, // Default is 6000 milliseconds
                                // nonLinearDuration: 20000, // Default is 15000 milliseconds
                                // maxDuration: 30000, // Default is false (DISABLED)
                                // locale: 'fr', // Any two-letter ISO 639-1 code. Default is false (Do not setup)
                                // disableLoader: true, // Default is false (Loader is enabled)
                            },
                        })
                    } else {
                        if(!this.watermark) {
                            this.player = new Clappr.Player({
                                source: Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8",
                                autoPlay: true,
                                plugins: {
                                    core: [ClapprGoogleImaHtml5PrerollPlugin],
                                },
                                width: "100%",
                                height: "100%",
                                googleImaHtml5PrerollPlugin: {
                                    tag: 'http://googleads.g.doubleclick.net/pagead/ads?ad_type=video&client=ca-video-pub-4968145218643279&videoad_start_delay=0&description_url=http%3A%2F%2Fwww.google.com&max_ad_duration=40000&adtest=on', // VAST tag URL (or false to disable plugin)
                                    vpaid: 0, // Default is 0 (0 is DISABLED, 1 is ENABLED and 2 is INSECURE)
                                    autostart: false, // Default is true
                                    // events: { /* Event map */ },
                                    // imaLoadTimeout: 3000, // Default is 6000 milliseconds
                                    // nonLinearDuration: 20000, // Default is 15000 milliseconds
                                    // maxDuration: 30000, // Default is false (DISABLED)
                                    // locale: 'fr', // Any two-letter ISO 639-1 code. Default is false (Do not setup)
                                    // disableLoader: true, // Default is false (Loader is enabled)
                                },
                            })
                        }
                    }
                    
                    
                } else {
                    if(this.watermark) {
                        this.player = new Clappr.Player({
                            source: Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8",
                            autoPlay: true,
                            width: "100%",
                            height: "100%",
                            watermark: "https://i.lsc-wx.co/site/watermark.png",
                            position: 'top-right'
                        })
                    } else {
                        this.player = new Clappr.Player({
                            source: Config.publicStreamPath + "/hls/" + _this.streamId + "/index.m3u8",
                            autoPlay: true,
                            width: "100%",
                            height: "100%",
                        })
                    }
                }

                this.player.attachTo(playerElement)
            }
		},
	}
</script>

<style>
	#videoHolder {
		width: 100%;
		height: 100%;
	}

    .video {
        width: 100%;
        height: 100%;
    }
</style>
